export default __webpack_public_path__ + "public/assets/images/f3c5a3f9660c955926b92c141db4bae3.png";